import { renderCustomColumnDefs } from "../../../../shared/Table/table.utils";
import { formatDate, renderAmount } from "../../../../utils";

/**
 * Gross for an invoice row. Uses the virtual total, then the stored calculated total.
 * @param {object} invoice
 * @returns {number}
 */
function invoiceGross(invoice) {
  if (!invoice) return 0;
  if (invoice.total != null && invoice.total !== 0) return invoice.total;
  return invoice.calculatedTotalCharges || invoice.total || 0;
}

// Config for Invoice report PDF table
const tableConfig = [
  {
    id: "invoiceId",
    // Function header: string headers go through camelCaseToSpaces ("Invoice I D")
    header: () => "Invoice ID",
    cell: ({ getValue }) => getValue() || "-",
  },
  {
    id: "dateCreated",
    header: "Date",
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return "-";
      return formatDate(value);
    },
  },
  {
    id: "client",
    header: "Client",
    cell: ({ getValue }) => {
      const client = getValue();
      if (!client) return "-";
      if (typeof client === "string") return client;
      return client?.name || client?.fullName || "-";
    },
  },
  {
    id: "status",
    header: "Status",
    cell: ({ getValue }) => getValue() || "-",
  },
  {
    id: "dueDate",
    header: "Due Date",
    cell: ({ getValue }) => {
      const value = getValue();
      if (!value) return "-";
      return formatDate(value);
    },
  },
  {
    id: "totalBaseCharges",
    header: "Base",
    cell: ({ getValue }) => renderAmount(getValue() || 0),
  },
  {
    id: "totalDropCharges",
    header: "Drop",
    cell: ({ getValue }) => renderAmount(getValue() || 0),
  },
  {
    id: "totalFuelCharges",
    header: "Fuel",
    cell: ({ getValue }) => renderAmount(getValue() || 0),
  },
  {
    id: "totalOtherCharges",
    header: "Other",
    cell: ({ getValue }) => renderAmount(getValue() || 0),
  },
  {
    id: "total",
    header: "Gross",
    cell: ({ row }) => renderAmount(invoiceGross(row.original)),
  },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);
